import { initWebAnalytics } from "@betterfield/analytics-web";

const apiKey = import.meta.env.VITE_POSTHOG_KEY;

if (!apiKey && import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn("[analytics] VITE_POSTHOG_KEY is not set — events will not be sent.");
}

/**
 * Single app-wide analytics client (PostHog EU, behind the vendor-neutral wrapper).
 * Privacy-first: nothing is captured until consent is granted (see AnalyticsBridge).
 * Call sites in TS get typed against BetterfieldEvents via useAnalytics<BetterfieldEvents>().
 */
export const analytics = initWebAnalytics({
  apiKey,
  // Points at PostHog's managed reverse proxy on our own neutral subdomain
  // (VITE_POSTHOG_HOST), so ad-blockers don't drop ingestion. Because api_host
  // is now that proxy, ui_host must point at the real PostHog UI for the
  // toolbar and dashboard links to work.
  apiHost: import.meta.env.VITE_POSTHOG_HOST,
  posthogConfig: {
    ui_host: "https://eu.posthog.com",
  },
});
